import React from 'react';
import { Form } from 'react-bootstrap';

const HeaderFooterCardForm = ({ formValues, setFormValues }) => (
    <div className="carousel-wrap pb-3">
        <Form.Group controlId="formCardHeader" className="mb-3">
            <Form.Label>Card Header</Form.Label>
            <Form.Control
                type="text"
                name="header"
                value={formValues.header || ''}
                onChange={(e) => setFormValues({ ...formValues, header: e.target.value })}
            />
        </Form.Group>
        <Form.Group controlId="formCardFooter" className="mb-3">
            <Form.Label>Card Footer</Form.Label>
            <Form.Control
                type="text"
                name="footer"
                value={formValues.footer || ''}
                onChange={(e) => setFormValues({ ...formValues, footer: e.target.value })}
            />
        </Form.Group>
        <Form.Group controlId="formCardTitle" className="mb-3">
            <Form.Label>Card Title</Form.Label>
            <Form.Control
                type="text"
                name="title"
                value={formValues.title || ''}
                onChange={(e) => setFormValues({ ...formValues, title: e.target.value })}
            />
        </Form.Group>
        <Form.Group controlId="formCardBodyText" className="mb-3">
            <Form.Label>Body Text</Form.Label>
            <Form.Control
                as="textarea"
                
                name="bodyText"
                value={formValues.bodyText || ''}
                onChange={(e) => setFormValues({ ...formValues, bodyText: e.target.value })}
            />
        </Form.Group>
    </div>
);

export default HeaderFooterCardForm;
